import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {Event} from '../../../models/event';
import {EventService} from '../../../services/event.service';
import {MatPaginator} from '@angular/material/paginator';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {EventPreviewService} from '../../../services/event-preview.service';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, Router} from "@angular/router";
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {KnowledgeService} from '../../../services/knowledge.service';
import {AlertComponent} from '../../../shared/dialogs/alert/alert.component';
import {EventDialogComponent} from '../../../event/dialogs/event-dialog/event-dialog.component';
import {EventPreviewDialogComponent} from '../../../event/dialogs/event-preview-dialog/event-preview-dialog.component';
import {ContextService} from '../../../services/context.service';
import {SpinnerService} from '../../../shared/waiting/spinner.service';

@Component({
  selector: 'app-congress-events',
  templateUrl: './congress-events.component.html',
  styleUrls: [ './congress-events.component.scss' ],
  entryComponents: [
    EventDialogComponent,
    ConfirmComponent
  ]
})

export class CongressEventsComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  public Editor = ClassicEditor;

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  // public displayedColumns: string[] = ['icon', 'date', 'name', 'preview', 'edit',  'letter', 'delete'];
  public displayedColumns: string[] = [ 'icon', 'date', 'name', 'preview', 'edit', 'delete' ];

  public selectedContext: any = null;
  public contexts: any[] = []

  public uid: any;

  public master: any;

  constructor (
    private db: AngularFirestore,
    public _contextService: ContextService,
    public _authService: AuthService,
    public _eventService: EventService,
    public _knowledgeService: KnowledgeService,
    public _eventPreviewService: EventPreviewService,
    private _activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    public router: Router,
    public _spinnerService: SpinnerService) {

    if (!this._authService.isOperator) {
      this.router.navigate([ 'home' ]);
    }
  }

  ngOnInit () {
    this._activeRoute.params.subscribe(params => {
      this.uid = params[ 'uid' ];
      // console.log("ngOnInit: " + this.uid)

      this.sub = this._eventService.selectByContext(this.uid)
    })
    this._eventService.isCongress = true;
    this._eventService.eventDataSource = null;
    this.getMaster(this.uid);
    //
  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();
  }

  async getMaster (context_id) {
    this.master = await this._contextService.getMasterEvent(context_id);
    /// console.log("Master: " + JSON.stringify(this.master))
  }

  openDialog (event) {

    let eventData: Event = new Event();

    if (event) {
      eventData = event;
    } else {
      eventData = new Event();
      eventData.context_id = this.selectedContext;
      eventData.belongsToProduct = false;
      eventData.limit_per_member = 1;
      eventData.master = false;

    }

    eventData.congress = true
    //console.log('eventData: ' + JSON.stringify(eventData))

    this.dialog.open(EventDialogComponent, {
      panelClass: 'custom-dialog-container',

      //width: '1000px',
      //height: '610px',
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",

      hasBackdrop: true,
      disableClose: true,
      data: eventData
    });

  }

  delete (element) {

    let event_id = element.id

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir este Evento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._eventService.canDeleteEvent(event_id)
          .then((empty) => {
            if (empty) {// empty == true : pode apagar
              //  console.log("pode apagar: " + event_id)

              this._eventService.delete(event_id)
                .then(() => {
                  console.log("delete event success")
                })
                .catch(() => {
                  console.log("error delete event")
                })

            } else { // empty false: não apaga 
              this.dialog.open(AlertComponent, {
                width: '350px',
                height: '270px',
                panelClass: 'custom-dialog-container',
                data: {title: "Alerta", message: "Este evento não pode ser excluído pois existe um produto associado a ele."}
              });

            }
          })
          .catch((error) => {
            console.log("canDelete event error: " + error.message)
          })

      }
    })
  }

  async preview (element) {

    const waiting = this._spinnerService.show();
    const ret: any = await this._eventPreviewService.getFullEvent({id: element.id});
    waiting.close();

    this.dialog.open(EventPreviewDialogComponent, {
      width: '800px',
      height: '610px',
      hasBackdrop: true,
      panelClass: 'custom-dialog-container',
      data: ret
    });

  }

  compareNames (a, b) {
    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;

  }

  gotoPublish () {
    const url = this.router.serializeUrl(this.router.createUrlTree([ 'event-publish/' + this.master.key ]));
    window.open(url, '_blank');
  }

  gotoSchedule () {
    //const url = this.router.serializeUrl(this.router.createUrlTree([ 'programa/' + this.master.key ]));
    //window.open(url, '_blank');
  }


}

